/* ============================================================
   Sideline Culture Co. — theme.js
   UI behavior (menu, accordion, nav scroll) + real Shopify
   AJAX cart + variant selection. No client-side page routing —
   Shopify handles real navigation between pages.
============================================================ */

document.addEventListener('DOMContentLoaded', () => {
  initMobileMenu();
  initNavScroll();
  initAccordion();
  initCartDrawerEvents();
  initProductForm();
  refreshCartBadgeFromCartJson();
});

/* ============ TOAST ============ */
let toastTimer;
function showToast(msg){
  const t = document.getElementById('toast');
  if(!t) return;
  t.textContent = msg;
  t.classList.add('is-shown');
  clearTimeout(toastTimer);
  toastTimer = setTimeout(() => t.classList.remove('is-shown'), 2400);
}

/* ============ MONEY FORMAT ============ */
function formatMoney(cents){
  const amount = (cents / 100).toFixed(2);
  return amount.endsWith('.00') ? '$' + amount.slice(0, -3) : '$' + amount;
}

/* ============ MOBILE MENU ============ */
function initMobileMenu(){
  const openBtn = document.getElementById('hamburgerBtn');
  const closeBtn = document.getElementById('mobileCloseBtn');
  const menu = document.getElementById('mobileMenu');
  if(!openBtn || !menu) return;
  openBtn.addEventListener('click', () => menu.classList.add('is-open'));
  if(closeBtn) closeBtn.addEventListener('click', () => menu.classList.remove('is-open'));
  menu.querySelectorAll('a').forEach(a => a.addEventListener('click', () => menu.classList.remove('is-open')));
}

/* ============ NAV SCROLL STATE ============ */
function initNavScroll(){
  const navEl = document.getElementById('SiteNav');
  if(!navEl) return;
  const onScroll = () => navEl.classList.toggle('is-scrolled', window.scrollY > 40);
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });
}

/* ============ ACCORDION ============ */
function initAccordion(){
  document.querySelectorAll('.acc-trigger').forEach(trigger => {
    if(trigger.dataset.bound) return;
    trigger.dataset.bound = 'true';
    trigger.addEventListener('click', () => {
      const item = trigger.closest('.acc-item');
      const panel = item.querySelector('.acc-panel');
      const isOpen = item.classList.contains('is-open');
      item.parentElement.querySelectorAll('.acc-item').forEach(i => {
        i.classList.remove('is-open');
        i.querySelector('.acc-panel').style.maxHeight = null;
      });
      if(!isOpen){
        item.classList.add('is-open');
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }
    });
  });
}

/* ============ CART DRAWER ============ */
function openCart(){
  const drawer = document.querySelector('[data-cart-drawer]');
  const overlay = document.getElementById('cartOverlay');
  if(drawer) drawer.classList.add('is-open');
  if(overlay) overlay.classList.add('is-open');
}
function closeCart(){
  const drawer = document.querySelector('[data-cart-drawer]');
  const overlay = document.getElementById('cartOverlay');
  if(drawer) drawer.classList.remove('is-open');
  if(overlay) overlay.classList.remove('is-open');
}

function initCartDrawerEvents(){
  const openBtn = document.getElementById('cartOpenBtn');
  const closeBtn = document.getElementById('cartCloseBtn');
  const overlay = document.getElementById('cartOverlay');

  if(openBtn && !openBtn.dataset.bound){
    openBtn.dataset.bound = 'true';
    openBtn.addEventListener('click', openCart);
  }
  if(closeBtn) closeBtn.addEventListener('click', closeCart);
  if(overlay) overlay.addEventListener('click', closeCart);

  document.querySelectorAll('[data-cart-remove]').forEach(link => {
    link.addEventListener('click', async (e) => {
      e.preventDefault();
      const line = parseInt(link.dataset.line, 10);
      await updateCartLine(line, 0);
    });
  });
}

async function updateCartLine(line, quantity){
  try {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line, quantity })
    });
    if(!res.ok) throw new Error('Cart update failed');
    await refreshCartSections();
  } catch(err){
    console.error(err);
    showToast("Something went wrong updating your bag");
  }
}

async function refreshCartSections(){
  try {
    const path = window.location.pathname;
    const res = await fetch(`${path}?sections=header,cart-drawer`);
    const data = await res.json();

    swapSection('shopify-section-header', data['header']);
    swapSection('shopify-section-cart-drawer', data['cart-drawer']);

    // re-bind events on the freshly swapped DOM
    initMobileMenu();
    initCartDrawerEvents();
    initNavScroll();
  } catch(err){
    console.error('Could not refresh cart sections', err);
  }
}

function swapSection(domId, html){
  if(!html) return;
  const existing = document.getElementById(domId);
  if(!existing) return;
  const temp = document.createElement('div');
  temp.innerHTML = html.trim();
  const fresh = temp.firstElementChild;
  if(fresh) existing.replaceWith(fresh);
}

async function refreshCartBadgeFromCartJson(){
  // Keeps the badge accurate even on a fresh page load (e.g. back/forward nav)
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    const badge = document.getElementById('cartCount');
    if(badge) badge.textContent = cart.item_count;
  } catch(err){ /* non-critical */ }
}

/* ============ PRODUCT FORM (variant select, qty, add to cart) ============ */
function initProductForm(){
  const form = document.getElementById('AddToCartForm');
  if(!form) return;

  const variantsEl = document.getElementById('ProductVariantsJson');
  const variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
  const sizeOpts = document.getElementById('sizeOpts');
  const selectedVariantInput = document.getElementById('SelectedVariantId');
  const priceEl = document.getElementById('productPrice');
  const addBtn = document.getElementById('addToCartBtn');

  function findVariant(selectedValue){
    if(!sizeOpts) return variants[0];
    const idx = parseInt(sizeOpts.dataset.optionIndex, 10);
    return variants.find(v => v.options[idx] === selectedValue) || variants[0];
  }

  function applyVariant(v){
    if(!v) return;
    if(selectedVariantInput) selectedVariantInput.value = v.id;
    if(priceEl) priceEl.textContent = formatMoney(v.price);
    if(addBtn) {
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? 'Add to Bag' : 'Sold Out';
    }
  }

  if(sizeOpts){
    sizeOpts.querySelectorAll('.size-opt').forEach(btn => {
      btn.addEventListener('click', () => {
        sizeOpts.querySelectorAll('.size-opt').forEach(b => b.classList.remove('is-active'));
        btn.classList.add('is-active');
        applyVariant(findVariant(btn.dataset.value));
      });
    });
  }

  // qty stepper
  const qtyMinus = document.getElementById('qtyMinus');
  const qtyPlus = document.getElementById('qtyPlus');
  const qtyVal = document.getElementById('qtyVal');
  const qtyInput = document.getElementById('QuantityInput');
  let qty = 1;
  function syncQty(){
    if(qtyVal) qtyVal.textContent = qty;
    if(qtyInput) qtyInput.value = qty;
  }
  if(qtyMinus) qtyMinus.addEventListener('click', () => { qty = Math.max(1, qty - 1); syncQty(); });
  if(qtyPlus) qtyPlus.addEventListener('click', () => { qty = Math.min(9, qty + 1); syncQty(); });

  // image gallery toggle (front/back/etc.)
  const viewToggle = document.getElementById('viewToggle');
  const mainImage = document.getElementById('productMainImage');
  if(viewToggle && mainImage){
    viewToggle.querySelectorAll('button').forEach(btn => {
      btn.addEventListener('click', () => {
        viewToggle.querySelectorAll('button').forEach(b => b.classList.remove('is-active'));
        btn.classList.add('is-active');
        mainImage.src = btn.dataset.imageUrl;
      });
    });
  }

  // submit -> AJAX add to cart
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    if(addBtn) addBtn.disabled = true;
    try {
      const formData = new FormData(form);
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      });
      const data = await res.json();
      if(data.status){
        // Shopify returns a `status` + `description`/`message` on error
        showToast(data.description || "That item couldn't be added");
      } else {
        showToast(`Added ${data.product_title || 'item'} to your bag`);
        await refreshCartSections();
        openCart();
      }
    } catch(err){
      console.error(err);
      showToast("Something went wrong adding that to your bag");
    } finally {
      if(addBtn) addBtn.disabled = false;
    }
  });
}
